module.exports = __webpack_public_path__ + "static-portal/img/54-1.6e43412.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/54-1.jpg
// module id = RrER
// module chunks = 4